import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <div className="relative flex-1 flex flex-col items-center justify-center text-center px-4 py-24">
        <p className="font-heading text-8xl md:text-[11rem] font-black text-background-200 select-none leading-none">
          404
        </p>
        <h1 className="relative mt-4 font-heading text-xl md:text-2xl font-bold text-foreground-950">
          这个页面不存在
        </h1>
        <p className="mt-3 text-sm text-foreground-500 break-all">
          {location.pathname}
        </p>
        <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-md leading-relaxed">
          你可能输错了地址，或者这份内容已经被移除。不妨回到首页，或者直接去调查档案里找找。
        </p>
        <div className="mt-8 flex flex-col sm:flex-row gap-3 w-full sm:w-auto">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors"
          >
            <i className="ri-home-4-line" aria-hidden="true"></i>
            返回首页
          </Link>
          <Link
            to="/cases"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer bg-background-100 border border-background-300 text-foreground-800 hover:border-primary-400 hover:text-primary-600 transition-colors"
          >
            <i className="ri-archive-2-line" aria-hidden="true"></i>
            浏览调查档案
          </Link>
        </div>
      </div>
    </div>
  );
}